/* eslint-disable clubmed/no-fake-component */
import React from 'react';
import { DateUtils } from 'react-day-picker';
import { classnames } from 'Utils/classnames/classnames.utils';
import { ICONS } from 'Components/utils/icon/icons';
import { formatMonthTitle } from 'Components/frameworks/datepicker/Datepicker.utils';
import { Icon } from 'Components/frameworks/icon/Icon';
type Props = {
  className?: string;
  date?: Date;
  fromMonth: Date;
  hasNavigationByYear?: boolean;
  isFormikInput: boolean;
  locale?: string;
  month?: Date;
  onNext: () => void;
  onPrevious: () => void;
  toMonth: Date;
};
export const DatepickerCaption = ({
  className,
  date = new Date(),
  fromMonth,
  hasNavigationByYear,
  isFormikInput,
  locale = 'en',
  month = new Date(),
  onNext,
  onPrevious,
  toMonth,
}: Props) => {
  if (!hasNavigationByYear && !isFormikInput) {
    return null;
  }

  const { isSameMonth } = DateUtils;
  const currentYear = date.getFullYear();
  const fromYear = fromMonth.getFullYear();
  const toYear = toMonth.getFullYear();

  const render = () => (
    <div className={classnames('flex items-center justify-between', className)}>
      {currentYear > fromYear && (
        <button className="size-30 touch-manipulation" onClick={() => onPrevious()} type="button">
          <Icon className="text-darkGrey" hasRtl name={ICONS.ARROW_LEFT} width="0.625rem" />
        </button>
      )}
      <span className="flex-1">{date.getFullYear()} </span>
      {currentYear < toYear && (
        <button className="size-30 touch-manipulation" onClick={() => onNext()} type="button">
          <Icon className="text-darkGrey" hasRtl name={ICONS.ARROW_RIGHT} width="0.625rem" />
        </button>
      )}
    </div>
  );

  const renderFormik = () => (
    <div className="flex items-center justify-between">
      {!isSameMonth(month, fromMonth) ? (
        <button
          className="h-36 w-30 touch-manipulation"
          data-testid="datepicker-arrow-prev"
          onClick={onPrevious}
          type="button"
        >
          <Icon className="text-darkGrey" hasRtl name={ICONS.ARROW_LEFT} width="0.625rem" />
        </button>
      ) : (
        <div className="h-36 w-30" />
      )}
      <span className="flex-1 text-center text-14">{formatMonthTitle(month, locale)}</span>
      {!isSameMonth(month, toMonth) ? (
        <button
          className="h-36 w-30 touch-manipulation"
          data-testid="datepicker-arrow-next"
          onClick={onNext}
          type="button"
        >
          <Icon className="text-darkGrey" hasRtl name={ICONS.ARROW_RIGHT} width="0.625rem" />
        </button>
      ) : (
        <div className="h-36 w-30" />
      )}
    </div>
  );

  return isFormikInput ? renderFormik() : render();
};
